<template>
  <div id="user-detail">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li><router-link :to="'/organizations'">Organisasi</router-link></li>
      <li class="active">Organisasi Detail</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Informasi Detail Organisasi</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Organisasi Info</h4>
          </div>
          <div class="panel-body">
            <div class="media">
              <a href="javascript:;" class="media-left">
                <img :src="organization.picture" alt="profile_picture" class="media-object">
              </a>
              <div class="media-body">
                <table class="table">
                  <tbody>
                    <tr>
                      <td style="width: 15%"><strong>Nama Organisasi</strong></td>
                      <td>{{ organization.name }}</td>
                    </tr>
                    <tr>
                      <td><strong>Nama Admin</strong></td>
                      <td>
                        <span v-for="(item, index) in organization.admin_data" :key="index">
                          {{ item.name }},
                        </span>
                        </td>
                    </tr>
                    <tr>
                      <td><strong>Provinsi</strong></td>
                      <td>{{ organization.province }}</td>
                    </tr>
                    <tr>
                      <td><strong>Kota/Kabupaten</strong></td>
                      <td>{{ organization.city }}</td>
                    </tr>
                    <tr>
                      <td><strong>NPSN</strong></td>
                      <td>{{ organization.npsn }}</td>
                    </tr>
                    <tr>
                      <td><strong>Alamat</strong></td>
                      <td>{{ organization.address }}</td>
                    </tr>
                    <tr>
                      <td><strong>No. Telpon</strong></td>
                      <td>{{ organization.contact }}</td>
                    </tr>
                    <tr>
                      <td><strong>Email Admin </strong></td>
                      <td>
                        <span v-for="(item, index) in organization.admin_data" :key="index">
                          {{ item.email }},
                        </span>
                        <!-- {{ organization.email }} -->
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Jumlah Cabang</strong></td>
                      <td>{{ organization.child_count }}</td>
                    </tr>
                    <tr>
                      <td colspan="2">
                        <router-link :to="{name: 'OrganizationForm', params: { id: organization.id }}" class="btn btn-success pull-right">
                          Edit
                        </router-link>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              Daftar Cabang
            </div>
            </div>
            <div class="panel-body">
            <!-- <div class="searchbox" style="width:100%;">
              <input type="text" class="form-control" v-model="query" @keyup.enter="loadStudentData(1)" placeholder="Masukkan kata kunci dan tekan enter">
            </div> -->
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Nama Cabang</th>
                  <th>Jumlah Siswa</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, index) in listCabang" :key="index">
                  <th>
                    {{  index + 1 }}
                  </th>
                  <th>
                    {{  item.name }}
                  </th>
                  <th>
                    {{ item.student_count }}
                  </th>
                </tr>
                </tbody>
                </table>
              </div>
            </div>
        <!-- <div class="panel panel-inverse">
          <div class="panel-heading" style="display:flex; justify-content:space-between; align-items:center;">
            <div style="width:50%;">
              {{ isMapping ? 'Mapping Siswa' : 'Daftar Siswa' }}
            </div>
            <div>
              <button v-if="!isMapping" class="btn btn-success" style="padding:5px; font-size: 11px;" @click="isBulkModal = true">
                Bulk Activation
              </button>
              <button class="btn btn-success" style="padding:5px; font-size: 11px;" @click="mappingToggle">
                {{ isMapping ? 'Cancel Mapping' : 'Mapping Siswa' }}
              </button>
              <button
                v-if="isMapping"
                :disabled="studentMaps.length === 0"
                class="btn btn-success"
                style="padding:5px; font-size: 11px;"
                @click="isBulkModal = true">
                  Submit Mapping Siswa
              </button>
            </div>
          </div>
          <div class="panel-body">
            <div class="searchbox" style="width:100%;">
              <input type="text" class="form-control" v-model="query" @keyup.enter="loadStudentData(1)" placeholder="Masukkan kata kunci dan tekan enter">
            </div>
            <table class="table table-hover">
              <thead>
                <tr>
                  <th>No.</th>
                  <th>Student Number</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone Number</th>
                  <th v-if="isMapping">Mapping</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(student, key) in students" v-bind:key="key">
                  <td>{{(25 * (pageNumber - 1)) + (key + 1)}}</td>
                  <td>{{student.student_number ? student.student_number.toUpperCase() : '-'}}</td>
                  <td>{{student.name.toUpperCase()}}</td>
                  <td>{{student.email.toUpperCase()}}</td>
                  <td>{{student.phone_number}}</td>
                  <td v-if="isMapping">
                    <div class="form-check">
                      <input class="form-check-input" type="checkbox" :value="student.user_id" v-model="studentMaps" :id="`check${key}`">
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="panel-footer">
            <div class="btn-group">
              <button class="btn btn-white" :disabled="pageNumber === 1" type="button" @click="loadStudentData(--pageNumber)">
                Previous
              </button>
              <input type="text" class="form-control" v-model="pageNumber" style="width: 50px; text-align: center">
              <button class="btn btn-white" :disabled="isDisabledNextBtn" type="button" @click="loadStudentData(++pageNumber)">
                Next
              </button>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <organizations-bulk
      v-if="isBulkModal"
      :isMapping="isMapping"
      @submitMapping="submitMapping"
      @reload="loadStudentData"
      @close="isBulkModal = false">
    </organizations-bulk>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<script>
import axios from 'axios'
import Spinner from '@/components/plugins/Spinner'
import OrganizationsBulk from '@/components/organizations/OrganizationsBulk'

export default {
  name: 'user-detail',
  components: {
    'app-spinner': Spinner,
    'organizations-bulk': OrganizationsBulk
  },
  data: function () {
    return {
      organization: {},
      listCabang: [],
      students: [],
      studentMaps: [],
      isLoading: true,
      pageNumber: 1,
      query: '',
      isMapping: false,
      isBulkModal: false,
      ossEndpoint: process.env.OSS_ENDPOINT,
      ossBucketName: process.env.OSS_BUCKET_NAME,
      organizationId: this.$route.params.id,
      isDisabledNextBtn: false
    }
  },
  methods: {
    loadStudentData: function () {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/usman/users'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url, {
        params: {
          page: this.pageNumber,
          query: this.query,
          organization_id: this.organizationId
        }
      })
        .then(function (response) {
          if (response.data.length < 25) {
            context.isDisabledNextBtn = true
          } else {
            context.isDisabledNextBtn = false
          }

          context.students = response.data
        })
        .catch(function (error) {
          console.log(error.message)
        })
        .then(function () {
          context.isLoading = false
        })
    },
    loadDetailData: function () {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/v2/organization/' + context.$route.params.id

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url)
        .then(function (response) {
          context.organization = response.data
        })
        .catch(function (error) {
          console.log(error.message)
        })
        .then(function () {
          context.isLoading = false
        })
    },
    loadListDaftarCabang: function () {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/v2/organization/' + context.$route.params.id + '/childs'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url)
        .then(function (response) {
          context.listCabang = response.data.data
        })
        .catch(function (error) {
          console.log(error.message)
        })
        .then(function () {
          context.isLoading = false
        })
    },
    submitMapping: function (duration) {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/b2b_mapping'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.post(url, {
        organization_id: this.$route.params.id,
        features: 'SCHEDULED_TRYOUT',
        duration,
        user_ids: this.studentMaps
      })
        .then(() => {
          alert('mapping berhasil')
          this.isLoading = false
          this.isBulkModal = false
          this.mappingToggle()
        })
        .catch(() => {
          alert('mapping error')
          this.isLoading = false
        })
    },
    mappingToggle: function () {
      if (this.isMapping) {
        this.isMapping = false
        this.organizationId = this.$route.params.id
      } else {
        this.isMapping = true
        this.organizationId = ''
      }

      this.loadStudentData()
    }
  },
  mounted: function() {
    this.loadDetailData()
    // this.loadStudentData()
    this.loadListDaftarCabang()
  },
  watch: {
    pageNumber: function(newVal) {
      this.loadStudentData(newVal)
    }
  },
}
</script>



// WEBPACK FOOTER //
// OrganizationDetail.vue?3ce61cee